export const IS_BOGO_PROMO_MODAL_DISMISSED = 'isBogoPromoModalDismissed'

export const isBogoPromoModalDismissed = () => {
  try {
    const item = window.localStorage.getItem(IS_BOGO_PROMO_MODAL_DISMISSED)

    return item === 'true'
  } catch (error) {
    return false
  }
}

export const setIsBogoPromoModalDismissed = () => {
  window.localStorage.setItem(
    IS_BOGO_PROMO_MODAL_DISMISSED,
    JSON.stringify(true),
  )
}
